module.exports = __webpack_public_path__ + "media/5.b2bf33e4.mp3";